// extracted by mini-css-extract-plugin
export var cardIcon = "_4p-4";
export var checkboxCard = "_4p-0";
export var checkboxCardSelected = "_4p-1";
export var disabled = "_4p-2";
export var outerBorder = "_4p-3";
export var spacerMedium = "_4p-7";
export var spacerSmall = "_4p-6";
export var spacerXsmall = "_4p-5";